import axios from 'axios';

// Create axios instance with base URL
// Prefer a relative base URL to leverage CRA proxy in development and same-origin in production.
// You can still override with REACT_APP_API_URL when needed.
const API = axios.create({
  baseURL: (process.env.REACT_APP_API_URL || '/api'),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      window.location.href = '/login';
    }

    // If the API is temporarily unavailable (e.g., DB not initialized),
    // surface a clearer message in the console but let callers handle UI.
    if (!error.response) {
      // Network error or server not reachable
      console.error('API unreachable. Check that the backend is running and the baseURL is correct:', API.defaults.baseURL);
    } else if (error.response.status === 503) {
      console.warn('Service unavailable (503). The backend may still be initializing or database not set up.');
    }

    return Promise.reject(error);
  }
);

export default API;
